import React, { useState } from 'react';
import { Box, Checkbox, FormControlLabel, Typography, Divider, Button, IconButton, TextField } from '@mui/material';
import { Close } from '@mui/icons-material';

export interface FilterOption {
    key: string;
    display_text: string;
}

export interface ColumnFilterProps {
    columnLabel: string;
    selected: string[];
    options: FilterOption[];
    onApply: (keys: string[]) => void;
    onClose: () => void;
    searchable?: boolean;
}

export const ColumnFilter: React.FC<ColumnFilterProps> = ({ columnLabel, selected, options, onApply, onClose, searchable }) => {
    const [localSelected, setLocalSelected] = useState<string[]>(selected);
    const [search, setSearch] = useState('');

    const filteredOptions = searchable && search
        ? options.filter(o => o.display_text.toLowerCase().includes(search.toLowerCase()))
        : options;

    const handleToggle = (key: string) => {
        setLocalSelected(prev =>
            prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
        );
    };

    return (
        <Box sx={{ p: 2, minWidth: 200 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle2">Filter by {columnLabel}</Typography>
                <IconButton size="small" onClick={onClose}>
                    <Close fontSize="small" />
                </IconButton>
            </Box>
            <Divider sx={{ mb: 1 }} />
            {searchable && (
                <TextField
                    size="small"
                    placeholder="Search..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    fullWidth
                    sx={{ mb: 1 }}
                />
            )}
            <Box sx={{ display: 'flex', flexDirection: 'column', maxHeight: 240, overflowY: 'auto' }}>
                {filteredOptions.map((option) => (
                    <FormControlLabel
                        key={option.key}
                        control={
                            <Checkbox
                                checked={localSelected.includes(option.key)}
                                onChange={() => handleToggle(option.key)}
                                size="small"
                            />
                        }
                        label={option.display_text}
                    />
                ))}
            </Box>
            <Divider sx={{ mt: 1 }} />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1.5 }}>
                <Button variant="outlined" size="small" onClick={() => onApply([])}>
                    Reset
                </Button>
                <Button variant="contained" size="small" color="primary" onClick={() => onApply(localSelected)}>
                    Apply
                </Button>
            </Box>
        </Box>
    );
}